import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  @Input('form') form
  @ViewChild('sessionExpiredModal', { static: true }) sessionExpiredModal: any;

  closeResult: string;

  constructor(
    private modalService: NgbModal,
    private route: Router
  ) { }

  ngOnInit() {
    this.open()
  }

  redirect() {
    this.route.navigate(['/login'])
  }

  open() {
    this.modalService.open(this.sessionExpiredModal, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static', centered: true }).result.then((result) => {
      // localStorage.clear();
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
}


